import { FormGroup } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { Resource } from "types";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { ContentLayout } from "../../Layout/ContentLayout";
import { EquipmentSchedule } from "./EquipmentSchedule";

interface EditScheduleProps {
    resource?: Resource;
}

export const EditSchedule = ({ resource }: EditScheduleProps) => {
    const history = useHistory();

    const handleCancel = () => {
        history.push("/resources/equipment");
    };

    if (!resource) {
        return null;
    }

    return (
        <ContentLayout>
            <div className="space-y-4">
                <FormGroup>
                    <EquipmentSchedule resource={resource} />
                </FormGroup>
            </div>
            <ContentLayout.Footer>
                <SecondaryButton type="reset" onClick={handleCancel}>
                    Cancel
                </SecondaryButton>
            </ContentLayout.Footer>
        </ContentLayout>
    );
};
